import { render, staticRenderFns } from "./ConversationSettingsDialog.vue?vue&type=template&id=607d5e76&scoped=true"
import script from "./ConversationSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ConversationSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./ConversationSettingsDialog.vue?vue&type=style&index=0&id=607d5e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d5e76",
  null
  
)

export default component.exports